module.exports = __webpack_public_path__ + "img/packup.2a84db7a.png";